import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=a28fd644&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=a28fd644&prod&scoped=true&lang=css"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=a28fd644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28fd644",
  null
  
)

export default component.exports